import { render, staticRenderFns } from "./ModalCompra.vue?vue&type=template&id=7b0ecd4e&scoped=true"
import script from "./ModalCompra.vue?vue&type=script&lang=js"
export * from "./ModalCompra.vue?vue&type=script&lang=js"
import style0 from "./ModalCompra.vue?vue&type=style&index=0&id=7b0ecd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0ecd4e",
  null
  
)

export default component.exports